export default __webpack_public_path__ + "static/media/slide19.2ffb3551.jpg";